import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableExporterModule } from 'mat-table-exporter';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthenticationService } from '../_services/authentication.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { User } from '../_model/user';
import { environment } from '../../environments/environment';
import { RequestService } from '../_services/request.service';
import { RequestmodalComponent } from './add/requestmodal.component';
import { RequestsdetailComponent } from './detail/requestsdetail.component';
import { LookupService } from '../_services/lookup.service';
import { EventService } from '../_services/event.service';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FormControl } from '@angular/forms';
import moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { Moment } from 'moment';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { UtilityService } from '../_helpers/utility.service';
import { RequestTableResponse } from '../_model/response/RequestTableResponse';

import { SelectionModel } from "@angular/cdk/collections";
import { Requests } from "../_model/Requests";
import { RequestsApproveComponent } from "./requestsApprove/requestsApprove.component";
import { RequestsCancelSelectedComponent } from "./requestsCancelSelected/requestsCancelSelected.component";
import { RequestsCompleteComponent } from "./requestsComplete/requestsComplete.component";
import { RequestrejectComponent } from "./requestsreject/requestsreject.component";
import { RequestsCompleteSelectedComponent } from "./requestsCompleteSelected/requestsCompleteSelected";
import { RequestsCancelComponent } from "./requestsCancel/requestsCancel.component";
import { RequestApproveSelected } from "./requestsApproveSelected/requestsApproveSelected.component";
import { RequestsRejectSelected } from "./requestsRejectSelected/requestsRejectSelected.component";
import { AppConstants } from '../_utils/constants';
import { PageEvent } from '@angular/material/paginator';

const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-requests',
    templateUrl: './requests.component.html',
    styleUrls: ['./requests.component.sass'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableExporterModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatTabsModule,
        MatSelectModule,
        MatIconModule,
        MatCheckboxModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatTooltipModule,
        MatDialogModule,
        MatDatepickerModule,
        FontAwesomeModule
    ],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
})
export class RequestsComponent implements OnInit, AfterViewInit {
    // Dummy data for table

    ngAfterViewInit(): void {
        // Paginator _intl ayarları
        if (this.allRequestPaginator) {
            this.allRequestPaginator._intl = this.paginatorIntl;
        }
        if (this.resultPaginator) {
            this.resultPaginator._intl = this.paginatorIntl;
        }
        if (this.processPaginator) {
            this.processPaginator._intl = this.paginatorIntl;
        }
        if (this.waitingsPaginator) {
            this.waitingsPaginator._intl = this.paginatorIntl;
        }
        if (this.myRequestPaginator) {
            this.myRequestPaginator._intl = this.paginatorIntl;
        }
    }

    @ViewChild('myRequestPaginator', { static: true }) myRequestPaginator: MatPaginator;
    @ViewChild('waitingsPaginator', { static: true }) waitingsPaginator: MatPaginator;
    @ViewChild('processPaginator', { static: true }) processPaginator: MatPaginator;
    @ViewChild('resultPaginator', { static: true }) resultPaginator: MatPaginator;
    @ViewChild('allRequestPaginator', { static: true }) allRequestPaginator: MatPaginator;

    displayedColumns: string[] = ['status', 'name', 'departmentName', 'reqClass', 'reqType', 'subject', 'description', 'createdAt', 'actions'];
    checkboxDisplayedColumns: string[] = ['select', 'status', 'name', 'departmentName', 'reqClass', 'reqType', 'subject', 'description', 'createdAt', 'actions']
    filterColumns: string[] = ['name', 'departmentName', 'reqClass', 'reqType', 'subject', 'description'];
    dsMyRequest: MatTableDataSource<any>;
    dsProcess: MatTableDataSource<any>;
    dsWaitings: MatTableDataSource<any>;
    dsMyResult: MatTableDataSource<any>;
    dsAllRequest: MatTableDataSource<any>;
    dsMyRequestCount: number;
    dsWaitingsCount: number;
    dsProcessCount: number;
    dsMyResultCount: number;
    dsAllRequestCount: number;

    filterValue = null;
    selectedTab = 0;
    currentUser: User;
    selectedRequest: Requests;
    selectedReq: Requests;
    fileUploadRoot = environment.fileUploadPath;

    // filter values
    reqClassList: any[] = [{ description: 'Hepsi' }];
    selectedReqClassDescription: string = this.reqClassList[0].description;
    startDateFilterValue1: any = new FormControl();
    endDateFilterValue1: any = new FormControl();
    startDateFilterValue2: any = new FormControl();
    endDateFilterValue2: any = new FormControl();
    startDateFilterValue3: any = new FormControl();
    endDateFilterValue3: any = new FormControl();
    startDateFilterValue4: any = new FormControl();
    endDateFilterValue4: any = new FormControl();
    departmentList: any[] = [{ description: 'Hepsi' }];
    selectedDepartment: string = this.departmentList[0].description;
    allRequestData: RequestTableResponse[] = [];
    selection = new SelectionModel<Request>(true, []);


    // fontawesome icon
    fileExcelIcon = faFileExcel;

    paginatorIntl = new MatPaginatorIntl();
    postPerPage: number;
    pageNumber: number;
    constructor(private requestsService: RequestService,
        private toastr: ToastrService,
        public dialog: MatDialog,
        public authService: AuthenticationService,
        public lookupService: LookupService,
        private eventService: EventService,
        private utilityService: UtilityService) { }

    ngOnInit() {
        // Initialize counts to 0
        this.dsMyRequestCount = 0;
        this.dsWaitingsCount = 0;
        this.dsProcessCount = 0;
        this.dsMyResultCount = 0;
        this.dsAllRequestCount = 0;

        this.requestsService.listRequests().subscribe(requests => {
            console.log('API Response:', requests); // Debug için API yanıtını logla

            if (!requests?.responseData?.items) {
                console.error('Invalid API response structure:', requests);
                return;
            }

            this.allRequestData = requests.responseData.items
                .sort((val1, val2) => new Date(val2.createdAt).getTime() - new Date(val1.createdAt).getTime());


            // Initialize data sources with filters and log counts
            const myRequests = this.allRequestData.filter(z => z.pageStatus === 'TALEPLERIM');
            const waitingRequests = this.allRequestData.filter(z => z.pageStatus === 'ONAY_BEKLEYENLER');
            const processRequests = this.allRequestData.filter(z => z.pageStatus === 'İŞLEMDE OLANLAR');
            const resultRequests = this.allRequestData.filter(z => z.pageStatus === 'SONUÇLANANLAR');
            const allRequests = this.allRequestData.filter(z => z.pageStatus === 'TÜM TALEPLER');


            this.dsMyRequest = new MatTableDataSource(myRequests);
            this.dsWaitings = new MatTableDataSource(waitingRequests);
            this.dsProcess = new MatTableDataSource(processRequests);
            this.dsMyResult = new MatTableDataSource(resultRequests);
            this.dsAllRequest = new MatTableDataSource(allRequests);



            // Set counts immediately
            this.dsMyRequestCount = myRequests.length;
            this.dsWaitingsCount = waitingRequests.length;
            this.dsProcessCount = processRequests.length;
            this.dsMyResultCount = resultRequests.length;
            this.dsAllRequestCount = allRequests.length;

            // Set paginators after data sources are initialized
            setTimeout(() => {
                if (this.dsMyRequest && this.myRequestPaginator) {
                    this.dsMyRequest.paginator = this.myRequestPaginator;
                }
                if (this.dsWaitings && this.waitingsPaginator) {
                    this.dsWaitings.paginator = this.waitingsPaginator;
                }
                if (this.dsProcess && this.processPaginator) {
                    this.dsProcess.paginator = this.processPaginator;
                }
                if (this.dsMyResult && this.resultPaginator) {
                    this.dsMyResult.paginator = this.resultPaginator;
                }
                if (this.dsAllRequest && this.allRequestPaginator) {
                    this.dsAllRequest.paginator = this.allRequestPaginator;
                }
            });
            this.dsMyRequest.filterPredicate =
                (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
                    JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.reqClass + ' ' + data.reqType + ' ' + data.description + ' ' + data.subject)).includes(filter);
            this.dsWaitings = new
                MatTableDataSource(this.allRequestData.filter(z => z.pageStatus == 'ONAY_BEKLEYENLER'));
            this.dsWaitings.paginator = this.waitingsPaginator;
            this.dsWaitings.filterPredicate =
                (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
                    JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.reqClass + ' ' + data.reqType + ' ' + data.description + ' ' + data.subject)).includes(filter);
            this.dsProcess = new
                MatTableDataSource(this.allRequestData.filter(z => z.pageStatus == 'İŞLEMDE OLANLAR'));
            this.dsProcess.paginator = this.processPaginator;
            this.dsProcess.filterPredicate =
                (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
                    JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.reqClass + ' ' + data.reqType + ' ' + data.description + ' ' + data.subject)).includes(filter);
            this.dsMyResult = new
                MatTableDataSource(this.allRequestData.filter(z => z.pageStatus == 'SONUÇLANANLAR'));
            this.dsMyResult.paginator = this.resultPaginator;
            this.dsMyResult.filterPredicate =
                (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
                    JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.reqClass + ' ' + data.reqType + ' ' + data.description + ' ' + data.subject)).includes(filter);
            this.dsAllRequest = new
                MatTableDataSource(this.allRequestData.filter(z => z.pageStatus == 'TÜM TALEPLER'));
            this.dsAllRequest.paginator = this.resultPaginator;
            this.dsAllRequest.filterPredicate =
                (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
                    JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.reqClass + ' ' + data.reqType + ' ' + data.description + ' ' + data.subject)).includes(filter);

            this.dsMyRequestCount = this.dsMyRequest.data.length;
            this.dsWaitingsCount = this.dsWaitings.data.length;
            this.dsProcessCount = this.dsProcess.data.length;
            this.dsMyResultCount = this.dsMyResult.data.length;
            this.dsAllRequestCount = this.dsAllRequest.data.length;

            this.dsMyRequestCount = this.dsMyRequest.data.length;
            this.dsWaitingsCount = this.dsWaitings.data.length;
            this.dsProcessCount = this.dsProcess.data.length;
            this.dsMyResultCount = this.dsMyResult.data.length;
            this.dsAllRequestCount = this.dsAllRequest.data.length;
            
        }, error => {
            this.toastr.error(error.error.msg, 'Hata');
        });
        this.currentUser = this.authService.currentUserValue;
        this.reqClassList.push(...this.lookupService.localListByLookupCode('REQ_CLASS').sort((a, b) =>
            a.lookupValue.toLowerCase().localeCompare(b.lookupValue.toLowerCase(), 'tr')));
        this.departmentList.push(...this.lookupService.localListByLookupCode('DEPARTMENT').filter(dept => dept.parentLookup || dept.parentLookup !== null).sort((a, b) =>
            a.lookupCode.toLowerCase().localeCompare(b.lookupCode.toLowerCase(), 'tr')));
        this.selectedReqClassDescription = this.reqClassList[0].description;
        this.paginatorIntl.itemsPerPageLabel = 'Satır sayısı';
        this.paginatorIntl.getRangeLabel = function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
                return 'Kayıt bulunamadı';
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            const endIndex = startIndex < length ?
                Math.min(startIndex + pageSize, length) :
                startIndex + pageSize;
            return length + ' Kayıttan ' + (startIndex + 1) + ' - ' + endIndex + ' arası ';
        };
    }

    onPaginate(pageEvent: PageEvent) {
        this.postPerPage = +pageEvent.pageSize;
        this.pageNumber = +pageEvent.pageIndex + 1;
        console.log("post per page  :  " + JSON.stringify(this.postPerPage));
        console.log("page number   :  " + JSON.stringify(this.pageNumber));
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dsWaitings.data.length;
        return numSelected === numRows;
    }
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dsWaitings.data.forEach(row => this.selection.select(row));
    }
    applyFilter1(event: Event) {
        this.filterValue = (event.target as HTMLInputElement).value;
        this.dsMyRequest.filter = this.utilityService.toTurkishLowerCase(this.filterValue.trim());
    }
    applyFilter2(event: Event) {
        this.filterValue = (event.target as HTMLInputElement).value;
        this.dsWaitings.filter = this.utilityService.toTurkishLowerCase(this.filterValue.trim());
    }
    applyFilter3(event: Event) {
        this.filterValue = (event.target as HTMLInputElement).value;
        this.dsProcess.filter = this.utilityService.toTurkishLowerCase(this.filterValue.trim());
    }
    applyFilter4(event: Event) {
        this.filterValue = (event.target as HTMLInputElement).value;
        this.dsMyResult.filter = this.utilityService.toTurkishLowerCase(this.filterValue.trim());
    }
    applyFilter5(event: Event) {
        this.filterValue = (event.target as HTMLInputElement).value;
        this.dsAllRequest.filter = this.utilityService.toTurkishLowerCase(this.filterValue.trim());
    }

    openRequestCreateModal() {
        const dialogRef = this.dialog.open(RequestmodalComponent, {
            width: '650px',
            height: 'auto',
            minHeight: '500px',
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => {
            this.dsMyRequest.data.unshift(result.data);
            this.dsMyRequest._updateChangeSubscription();
        });
    }

    openUpdateModal(requests: Requests) {
        this.selectedRequest = requests;
        this.requestsService.getById(this.selectedRequest.id).subscribe(result => {
            let dialogRef = this.dialog.open(RequestmodalComponent, {
                width: '650px',
                height: 'auto',
                data: result.responseData.item
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    const requestIndex = this.dsMyRequest.data.findIndex(abs => abs.id === result.data.id);
                    this.dsMyRequest.data.splice(requestIndex, 1, result.data);
                    this.dsMyRequest._updateChangeSubscription();
                }
                // tabloda ilgili satiri bul ve yer degistir
                if (this.filterValue != null) {
                    this.dsMyRequest.filter = this.utilityService.toTurkishLowerCase(this.filterValue.trim());
                }
            });
        });

        //this.dsMyRequest.filter = null;
    }
    openApproveModal(requests: Requests) {
        this.selectedRequest = requests;

        const dialogRef = this.dialog.open(RequestsApproveComponent, {
            width: '400px',
            minHeight: '80px',
            data: requests
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                const requestIndex = this.dsWaitings.data.findIndex(rqs => rqs.id === requests.id);
                this.dsWaitings.data.splice(requestIndex, 1);
                this.dsWaitings._updateChangeSubscription();
            }
        });
    }

    openRejectModal(requests: Requests) {
        this.selectedRequest = requests;

        const dialogRef = this.dialog.open(RequestrejectComponent, {
            width: '400px',
            data: requests
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                const requestIndex = this.dsWaitings.data.findIndex(rqs => rqs.id === requests.id);
                this.dsWaitings.data.splice(requestIndex, 1);
                this.dsWaitings._updateChangeSubscription();
            }
        });
    }
    openApproveSelectedModal() {
        const dialogRef = this.dialog.open(RequestApproveSelected, {
            width: '300px',
            data: this.selection.selected
        });

        dialogRef.afterClosed().subscribe(result => {
            this.ngOnInit();
        });
    }

    openRejectSelectedModal() {
        const dialogRef = this.dialog.open(RequestsRejectSelected, {
            width: '300px',
            data: this.selection.selected
        });

        dialogRef.afterClosed().subscribe(result => {
            this.ngOnInit();
        });
    }
    openCompleteModal(requests: Requests) {
        this.selectedRequest = requests;

        const dialogRef = this.dialog.open(RequestsCompleteComponent, {
            width: '400px',
            minHeight: '80px',
            data: requests
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                const requestIndex = this.dsWaitings.data.findIndex(rqs => rqs.id === requests.id);
                this.dsProcess.data.splice(requestIndex, 1);
                this.dsProcess._updateChangeSubscription();
            }
        });
    }
    openCancelModal(requests: Requests) {
        this.selectedRequest = requests;

        const dialogRef = this.dialog.open(RequestsCancelComponent, {
            width: '400px',
            data: requests
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                const requestIndex = this.dsWaitings.data.findIndex(rqs => rqs.id === requests.id);
                this.dsProcess.data.splice(requestIndex, 1);
                this.dsProcess._updateChangeSubscription();
            }
        });
    }

    openCancelSelectedModal() {
        const dialogRef = this.dialog.open(RequestsCancelSelectedComponent, {
            width: '300px',
            data: this.selection.selected
        });

        dialogRef.afterClosed().subscribe(result => {
            this.ngOnInit();
        });
    }
    opencompleteSelectedModal() {
        const dialogRef = this.dialog.open(RequestsCompleteSelectedComponent, {
            width: '300px',
            data: this.selection.selected
        });

        dialogRef.afterClosed().subscribe(result => {
            this.ngOnInit();
        });
    }

    openDetail(row) {
        let dialogRef = null;
        this.requestsService.getById(row.id).subscribe(value => {
            dialogRef = this.dialog.open(RequestsdetailComponent, {
                width: '550px',
                height: 'auto',
                data: value.responseData.item
            });
        });
    }

    reqClassChanged(tabNo: number) {

        const tableFilters = [];
        tableFilters.push({
            id: 'reqClass',
            value: this.selectedReqClassDescription
        });
        if (tabNo === 0) {
            this.dsMyRequest.filter = JSON.stringify(tableFilters);
            if (this.dsMyRequest.paginator) {
                this.dsMyRequest.paginator.firstPage();
            }
        } else if (tabNo === 1) {
            this.dsWaitings.filter = JSON.stringify(tableFilters);
            if (this.dsWaitings.paginator) {
                this.dsWaitings.paginator.firstPage();
            }
        } else if (tabNo === 2) {
            this.dsProcess.filter = JSON.stringify(tableFilters);
            if (this.dsProcess.paginator) {
                this.dsProcess.paginator.firstPage();
            }
        } else if (tabNo === 3) {
            this.dsMyResult.filter = JSON.stringify(tableFilters);
            if (this.dsMyResult.paginator) {
                this.dsMyResult.paginator.firstPage();
            }
        } else if (tabNo === 4) {
            this.dsAllRequest.filter = JSON.stringify(tableFilters);
            if (this.dsAllRequest.paginator) {
                this.dsAllRequest.paginator.firstPage();
            }
        }
    }

    chosenYearHandler(normalizedYear: Moment, tabNo: number) {
        if (tabNo === 0) {
            const ctrlValue = this.startDateFilterValue1.value;
            ctrlValue.year(normalizedYear.year());
            this.startDateFilterValue1.setValue(ctrlValue);
        } else if (tabNo === 1) {
            const ctrlValue = this.startDateFilterValue2.value;
            ctrlValue.year(normalizedYear.year());
            this.startDateFilterValue2.setValue(ctrlValue);
        } else if (tabNo === 2) {
            const ctrlValue = this.startDateFilterValue3.value;
            ctrlValue.year(normalizedYear.year());
            this.startDateFilterValue3.setValue(ctrlValue);
        } else if (tabNo === 3) {
            const ctrlValue = this.startDateFilterValue4.value;
            ctrlValue.year(normalizedYear.year());
            this.startDateFilterValue4.setValue(ctrlValue);
        }
    }

    chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, tabNo: number) {
        if (tabNo === 0) {
            const ctrlValue = this.startDateFilterValue1.value;
            ctrlValue.month(normalizedMonth.month());
            this.startDateFilterValue1.setValue(ctrlValue);
        } else if (tabNo === 1) {
            const ctrlValue = this.startDateFilterValue2.value;
            ctrlValue.month(normalizedMonth.month());
            this.startDateFilterValue2.setValue(ctrlValue);
        } else if (tabNo === 2) {
            const ctrlValue = this.startDateFilterValue3.value;
            ctrlValue.month(normalizedMonth.month());
            this.startDateFilterValue3.setValue(ctrlValue);
        } else if (tabNo === 3) {
            const ctrlValue = this.startDateFilterValue4.value;
            ctrlValue.month(normalizedMonth.month());
            this.startDateFilterValue4.setValue(ctrlValue);
        }
        //datepicker.close();
    }

    chosenYear2Handler(normalizedYear: Moment, tabNo: number) {
        if (tabNo === 0) {
            console.log('enddate filter value year = ' + JSON.stringify(this.endDateFilterValue1));
            const ctrlValue = this.endDateFilterValue1.value;
            ctrlValue.year(normalizedYear.year());
            this.endDateFilterValue1.setValue(ctrlValue);
        } else if (tabNo === 1) {
            const ctrlValue = this.endDateFilterValue2.value;
            ctrlValue.year(normalizedYear.year());
            this.endDateFilterValue2.setValue(ctrlValue);
        } else if (tabNo === 2) {
            const ctrlValue = this.endDateFilterValue3.value;
            ctrlValue.year(normalizedYear.year());
            this.endDateFilterValue3.setValue(ctrlValue);
        } else if (tabNo === 3) {
            const ctrlValue = this.endDateFilterValue4.value;
            ctrlValue.year(normalizedYear.year());
            this.endDateFilterValue4.setValue(ctrlValue);
        }
    }

    chosenMonth2Handler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, tabNo: number) {
        if (tabNo === 0) {
            console.log('enddate filter value month = ' + JSON.stringify(this.endDateFilterValue1));
            const ctrlValue = this.endDateFilterValue1.value;
            ctrlValue.month(normalizedMonth.month());
            this.endDateFilterValue1.setValue(ctrlValue);
        } else if (tabNo === 1) {
            const ctrlValue = this.endDateFilterValue2.value;
            ctrlValue.month(normalizedMonth.month());
            this.endDateFilterValue2.setValue(ctrlValue);
        } else if (tabNo === 2) {
            const ctrlValue = this.endDateFilterValue3.value;
            ctrlValue.month(normalizedMonth.month());
            this.endDateFilterValue3.setValue(ctrlValue);
        } else if (tabNo === 3) {
            const ctrlValue = this.endDateFilterValue4.value;
            ctrlValue.month(normalizedMonth.month());
            this.endDateFilterValue4.setValue(ctrlValue);
        }
        //datepicker.close();
    }

    filterGrid(tabNo: number, pageStatus: string, startDate, endDate) {

        if (startDate > endDate) {
            this.toastr.error('Başlangıç tarihi bitiş tarihinden sonra olamaz!!!', 'Uyarı');
            return;
        }

        // change datasource by using filters
        if (tabNo === 0) {
            this.dsMyRequest.data = this.filterData(pageStatus, tabNo);
        } else if (tabNo === 1) {
            this.dsWaitings.data = this.filterData(pageStatus, tabNo);
        } else if (tabNo === 2) {
            this.dsProcess.data = this.filterData(pageStatus, tabNo);
        } else if (tabNo === 3) {
            this.dsMyResult.data = this.filterData(pageStatus, tabNo);
        } else if (tabNo === 4) {
            this.dsAllRequest.data = this.filterData(pageStatus, tabNo);
        }
    }

    clearfilterGrid(tabNo: number, pageStatus: string) {
        this.selectedReqClassDescription = this.reqClassList[0].description;
        this.selectedDepartment = this.departmentList[0].description;
        if (tabNo === 0) {
            this.startDateFilterValue1.setValue(null);
            this.endDateFilterValue1.setValue(null);
        } else if (tabNo === 1) {
            this.startDateFilterValue2.setValue(null);
            this.endDateFilterValue2.setValue(null);
        } else if (tabNo === 2) {
            this.startDateFilterValue3.setValue(null);
            this.endDateFilterValue3.setValue(null);
        } else if (tabNo === 3) {
            this.startDateFilterValue4.setValue(null);
            this.endDateFilterValue4.setValue(null);
        }
        this.filterGrid(tabNo, pageStatus, null, null);
    }

    filterData(pageStatus, tabNo) {
        return this.allRequestData.filter(z => z.pageStatus === pageStatus)
            .filter(value => {
                if ((this.selectedReqClassDescription != null && this.selectedReqClassDescription !== undefined) &&
                    this.selectedReqClassDescription !== 'Hepsi') {
                    if (value.reqClass === this.selectedReqClassDescription) {
                        return value;
                    }
                } else {
                    return value;
                }
            })
            .filter(value => {
                if ((this.selectedDepartment != null && this.selectedDepartment !== undefined) &&
                    this.selectedDepartment !== 'Hepsi') {
                    if (value.departmentName === this.selectedDepartment) {
                        return value;
                    }
                } else {
                    return value;
                }
            })
            .filter(value => {
                let tempStartDateVal;
                if (tabNo === 0) {
                    tempStartDateVal = this.startDateFilterValue1.value;
                } else if (tabNo === 1) {
                    tempStartDateVal = this.startDateFilterValue2.value;
                } else if (tabNo === 2) {
                    tempStartDateVal = this.startDateFilterValue3.value;
                } else if (tabNo === 3) {
                    tempStartDateVal = this.startDateFilterValue4.value;
                }
                if ((tempStartDateVal != null && tempStartDateVal !== undefined)) {
                    if (moment(new Date(value.createdAt), AppConstants.MOMENT_DATETIME_FORMAT) >= tempStartDateVal) {
                        return value;
                    }
                } else {
                    return value;
                }
            })
            .filter(value => {
                let tempEndDateVal;
                if (tabNo === 0) {
                    tempEndDateVal = this.endDateFilterValue1.value;
                } else if (tabNo === 1) {
                    tempEndDateVal = this.endDateFilterValue2.value;
                } else if (tabNo === 2) {
                    tempEndDateVal = this.endDateFilterValue3.value;
                } else if (tabNo === 3) {
                    tempEndDateVal = this.endDateFilterValue4.value;
                }
                if ((tempEndDateVal != null && tempEndDateVal !== undefined) && value.startDate != null) {
                    if (moment(new Date(value.createdAt), AppConstants.MOMENT_DATETIME_FORMAT) <= tempEndDateVal) {
                        return value;
                    }
                } else {
                    return value;
                }
            });
    }
}
